import { render, staticRenderFns } from "./MojarOld.vue?vue&type=template&id=0e10d3c8&"
import script from "./MojarOld.vue?vue&type=script&lang=js&"
export * from "./MojarOld.vue?vue&type=script&lang=js&"
import style0 from "./MojarOld.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports